'use client';

import React from 'react';
import { IndustryTiles } from '@sapientpro/sapientpro-data-models';
import { useAtomValue } from 'jotai';
import styles from './IndustryCard.module.scss';
import Img from '../../../../components/Img';
import { theme, Theme } from '../../../../store/theme';

interface IProps {
  industry: IndustryTiles;
}

const IndustryCard = ({ industry }: IProps) => {
  const appTheme = useAtomValue<Theme>(theme);

  return (
    <div className={styles.industry}>
      <div className={styles.imageWrapper}>
        <Img
          src={industry.icon?.[appTheme]?.url}
          alt={industry.icon?.[appTheme]?.alternativeText || 'industry'}
          className={styles.image}
          key={appTheme}
        />
      </div>
      <p className={styles.title}>{industry.title}</p>
    </div>
  );
};

export default IndustryCard;
